
import 'react-tabs/style/react-tabs.css';
import { provideGlobalGridOptions } from 'ag-grid-community';
import { observer } from 'mobx-react-lite';
import context from '../Administration/context/shared';
import Administration from '../Administration/Administration';
import Statisctics from '../Statistics/Statisctics';
import HardwareCommands from '../Statistics/HardwareCommands';
import { InputPicker } from 'rsuite';
import { ToolsPanel } from '../ToolsPanel';
import { useBackButton } from '../../utils/backButton';
import '../../styles/MobileCenter.css'
// Mark all grids as using legacy themes
provideGlobalGridOptions({
    theme: "legacy",
});

const MobileCenter = observer(() => {

    const { tabIndex, setTabIndex } = context;
    useBackButton(() => setTabIndex(0), tabIndex !== 0);
    const tabs = [
        {
            index: 0,
            title: "Администрирование",
            render: (isActive: boolean) => <Administration />
        },
        {
            index: 1,
            title: "Аппаратные команды",
            render: (isActive: boolean) => <HardwareCommands tabIsActive={isActive} />
        },
    ].filter(Boolean);
 
    return (
        <div id="body">
            <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }} >
                <ToolsPanel />
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', marginBottom: '.5rem' }} >
                    <label>Режим: </label>
                    <InputPicker
                        data={tabs}
                        labelKey='title'
                        valueKey='index'
                        cleanable={false}
                        value={tabIndex}
                        onChange={setTabIndex}
                        style={{ width: '60%', marginLeft: '1rem'} }
                    />
                </div>
                
                <div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
                    {tabs.map((tab, idx) => (
                        tabIndex === idx ? tab.render(tabIndex === idx) : <></>
                    ))}
                </div>
            </div>
        </div>
    );   
})
export default MobileCenter;
